import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PortalApiService } from '../portal-api.service';
import { PortalAuthService } from '../portal-auth.service';
import { PortalBrandingService } from '../portal-branding.service';

@Component({
	selector: 'portal-accept-invite',
	templateUrl: './accept-invite.component.html',
	styleUrls: ['./accept-invite.component.scss']
})
export class AcceptInviteComponent implements OnInit {
	readonly product = 'WeProject';

	token = '';
	invite: any = null;
	loadingInvite = true;
	loadError = '';

	// 'intro' = the welcome / continue step; 'password' = create-a-password step.
	step: 'intro' | 'password' = 'intro';

	firstName = '';
	lastName = '';
	password = '';
	passwordConf = '';
	error = '';
	submitting = false;

	constructor(
		private route: ActivatedRoute,
		private api: PortalApiService,
		private auth: PortalAuthService,
		public branding: PortalBrandingService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.token = this.route.snapshot.paramMap.get('token') || '';
		if (!this.token) {
			this.loadingInvite = false;
			this.loadError = 'Invalid invitation link.';
			return;
		}

		this.api.auth.inviteDetails(this.token, (res: any) => {
			this.loadingInvite = false;
			this.invite = res?.invite || null;
			// Prefill first/last from the invite's stored name, if any.
			const parts = (this.invite?.name || '').trim().split(/\s+/).filter(Boolean);
			this.firstName = parts[0] || '';
			this.lastName = parts.slice(1).join(' ') || '';
			this.branding.apply(res?.branding);
		}, (err: any) => {
			this.loadingInvite = false;
			this.loadError = err?.message || 'This invitation link is no longer valid.';
		});
	}

	// The project the invitee is joining, e.g. "The Boathouse".
	get projectName(): string {
		return this.invite?.project_description || this.invite?.project_no || 'the project';
	}

	// The organisation that sent the invite, e.g. "AudioVisions".
	get orgName(): string {
		return this.invite?.org_name || this.branding.companyName;
	}

	get inviterName(): string {
		return (this.invite?.inviter_name || '').trim();
	}

	// Step 1 → Step 2. People who already have a password sign in instead (which
	// accepts the invite on login); everyone else sets a password here.
	continue(): void {
		if (this.invite?.password_set) {
			this.router.navigate(['/login']);
			return;
		}
		this.error = '';
		this.step = 'password';
	}

	submit(): void {
		this.error = '';
		// if (!this.firstName.trim()) { this.error = 'Please enter your first name.'; return; }
		if (this.password.length < 7) { this.error = 'Password must be at least 7 characters long.'; return; }
		if (this.password !== this.passwordConf) { this.error = 'Please enter the same password twice to confirm.'; return; }

		this.submitting = true;
		this.api.auth.acceptInvite({
			token: this.token,
			first_name: this.firstName.trim(),
			last_name: this.lastName.trim(),
			password: this.password,
			password_conf: this.passwordConf
		}, (res: any) => {
			this.submitting = false;
			this.branding.apply(res?.branding);
			this.auth.setUser(res?.user || null);
			this.router.navigate(['/']);
		}, (err: any) => {
			this.submitting = false;
			this.error = err?.message || 'We could not complete your registration.';
		});
	}

	signIn(): void {
		this.router.navigate(['/login']);
	}
}
